export enum Languages {
  hu = 1,
  en = 2,
}
